import React, { useState } from 'react';
import axios from 'axios';
import { Form, FormGroup, FormLabel, FormControl, Button, Image, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import { useResto } from '../contexts/RestoContext';
import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext';
import { ucfirst } from '../utils/utils';

const PressAddItem = ({ handleAddItem }) => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const { restoData } = useResto();
  const { setIsLoading } = useWebsite();
  
  const defaultFormData = {
    website: restoData.website,
    descriptionFr: '',
    descriptionEn: '',
    descriptionDe: '',
    descriptionEs: '',
    label: '',
    url: '',
  };

  const [formData, setFormData] = useState(defaultFormData);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const resetFormData = () => {
    setFormData(defaultFormData);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(`${config.apiUrl}press`, formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      handleAddItem();
      resetFormData();
      setFlashMessage(t('SUCCESS_CREATED_MESSAGE'), 'success');
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error');
      console.error('An error occurred while adding item:', error);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <div className="p-3">
        <Form onSubmit={handleSubmit}>
        <Row className='margin-top-20'>
            <Col>
              <FormGroup>
                <FormLabel htmlFor="label">Titre de l'article</FormLabel>
                <FormControl type="text" id="label" name="label" value={formData.label} onChange={handleChange} required />
              </FormGroup>
            </Col>
          </Row>
          <Row className='margin-top-20'>
            <Col>
              <FormGroup>
                <FormLabel htmlFor="url">{t('URL')}</FormLabel>
                <FormControl type="url" id="url" name="url" value={formData.url} onChange={handleChange} placeholder='https://www.l-article.fr' required />
              </FormGroup>
            </Col>
          </Row>
          <Row className='margin-top-20'>
            {restoData.availableLanguages.map((language, index) => (
              <Col key={index}>
                    <FormGroup>
                        <FormLabel htmlFor={`description${ucfirst(language)}`}>Description <Image src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`} className="flag-label" alt={`Description ${language}`} /></FormLabel>
                        <FormControl 
                            as="textarea"
                            rows={3} 
                            id={`description${ucfirst(language)}`} 
                            name={`description${ucfirst(language)}`} 
                            value={formData[`description${ucfirst(language)}`]} 
                            onChange={handleChange} />
                    </FormGroup>
              </Col>
            ))}
          </Row>
          <div className="text-center margin-top-20" style={{ marginBottom: '60px'}}>
            <Button type="submit">{t('ADD')}</Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default PressAddItem;
